const __config = {
  logkey: ''
}

export function register(config) {
  window.__portraitCollector.__config = Object.assign(__config, config)
}

export function get() {
  return __config
}
